import React from "react";
import ResumeButton from "@components/FlowActionButtons/ResumeButton";
import { canUserResumeInterruption } from "../utils";

interface ResumeVesselCallProps {
  vesselCallFlowData?: {
    status: string;
    companyId?: string;
  };
  openDrawer: (drawerName: string) => void;
}

const LANG_BASE = "vessel-call.vessel-call-status-header";

const ResumeVesselCall: React.FC<ResumeVesselCallProps> = ({ vesselCallFlowData, openDrawer }) => {
  if (!vesselCallFlowData) {
    return null;
  }
  const isActionAvailable = canUserResumeInterruption(
    vesselCallFlowData.status,
    vesselCallFlowData.companyId,
  );
  const handleResumeClick = () => {
    openDrawer("resumeVesselCallDrawer");
  };

  return (
    <ResumeButton
      langBase={LANG_BASE}
      permission="canResumeVesselCall"
      isActionAvailable={isActionAvailable}
      onResume={handleResumeClick}
    />
  );
};
export default ResumeVesselCall;
